import {
  IImomoResponse,
  IUser,
  IRequestResetPasswordData,
  IResetPasswordData,
  IChangePasswordData,
  IInvitationData,
  IInvitationDetails,
  IInvitedUserData} from './api.types';

export interface IUserApi {
  getCurrentUser():ng.IPromise<any>;
  getUserList(): ng.IPromise<IUser[]>;
  getUser(id: number | string): ng.IPromise<any>;
  deleteUser(id: number): ng.IPromise<any>;
  saveUser(userData: IUser): ng.IPromise<IUser>;
  requestResetPassword(data: IRequestResetPasswordData): ng.IPromise<void>;
  resetPassword(data: IResetPasswordData): ng.IPromise<void>;
  changePassword(data: IChangePasswordData): ng.IPromise<void>;
  sendInvitation(data: IInvitationData): ng.IPromise<IInvitationDetails>;
  getInvitationDetails(uuid: string): ng.IPromise<IInvitationDetails>;
  createUserFromInvitation(data: IInvitedUserData, uuid: string): ng.IPromise<void>;
}

export default class UserApi implements IUserApi {
  static $inject = ['$http', 'backendUrl'];

  private usersEndpoint: string;

  constructor(private $http: ng.IHttpService,
              private backendUrl: string) {
    this.usersEndpoint = `${backendUrl}/users`;
  }

  getCurrentUser(): ng.IPromise<IUser> {
    return this.$http<IImomoResponse<IUser>>({
      url: `${this.usersEndpoint}/me`,
      method: 'GET'
    }).then(httpData => httpData.data.resources[0]);
  }

  getUser(id: number | string): ng.IPromise<IUser> {
      return this.$http<IImomoResponse<IUser>>({
          url: `${this.usersEndpoint}/` + id,
          method: 'GET'
      }).then(httpData => httpData.data.resources[0]);
  }

  deleteUser(id: number): ng.IPromise<void> {
      return this.$http({
          url: `${this.usersEndpoint}/` + id,
          method: 'DELETE'
      }).then(function(data) {
      });
  }

  getUserList(): ng.IPromise<IUser[]> {
      return this.$http<IImomoResponse<IUser>>({
          url: `${this.usersEndpoint}`,
          method: 'GET'
      }).then(httpData => httpData.data.resources);
  }

  saveUser(user: IUser): ng.IPromise<IUser> {
      return this.$http<IImomoResponse<IUser>>({
          url: `${this.usersEndpoint}` + (user.id || user.id === 0 ? `/${user.id}`: ''),
          method: user.id || user.id === 0 ? 'PUT':'POST',
          data: user
      }).then(httpData => httpData.data.resources[0]);
  }

  requestResetPassword(data: IRequestResetPasswordData): ng.IPromise<void> {
      return this.$http({
          url: `${this.usersEndpoint}/request_reset_password`,
          method: 'POST',
          data: data
      }).then(function(data) {
      });
  }

  resetPassword(data: IResetPasswordData): ng.IPromise<void> {
      return this.$http({
          url: `${this.usersEndpoint}/reset_password`,
          method: 'POST',
          data: data
      }).then(function(data) {
      });
  }

  changePassword(data: IChangePasswordData): ng.IPromise<void> {
      return this.$http({
          url: `${this.usersEndpoint}/change_password`,
          method: 'POST',
          data: data
      }).then(function(data) {
      });
  }

  sendInvitation(data: IInvitationData): ng.IPromise<IInvitationDetails> {
    return this.$http<IImomoResponse<IInvitationDetails>>({
        url: `${this.usersEndpoint}/invitations`,
        method: 'POST',
        data: data
    }).then(httpData => httpData.data.resources[0]);
  }

  getInvitationDetails(uuid: string): ng.IPromise<IInvitationDetails> {
    return this.$http<IImomoResponse<IInvitationDetails>>({
        url: `${this.usersEndpoint}/invitations/${uuid}`,
        method: 'GET'
    }).then(httpData => httpData.data.resources[0]);
  }

  createUserFromInvitation(data: IInvitedUserData, uuid: string): ng.IPromise<void> {
    return this.$http({
        url: `${this.usersEndpoint}/invitations/${uuid}/register`,
        method: 'POST',
        data: data
    }).then(function(data) {
    });
  }
}



/** WEBPACK FOOTER **
 ** ./app/api/user-api.service.ts
 **/